import { Fragment } from 'react';
import { Button, Card, Col, Form, Row, Table } from 'react-bootstrap';
import Select from 'react-select';

import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';
import type { AudienciaPresencialItem, AudienciaRemotaItem } from '../relatorio-civel-page.models';

export default function Step08Audiencias(props: RelatorioCivelStepProps) {
  const {
    cardStyle,
    headerStyle,
    TIPOS_AUDIENCIAS,
    isViewMode,
    apenasNumeros,
    formatarDataHelper,
    quantidadeLinhas,
    setQuantidadeLinhas,
    formData,

    // Presenciais
    novaAudienciaPresencial,
    setNovaAudienciaPresencial,
    novoNumeroProtocolo,
    setNovoNumeroProtocolo,
    novaDataPresencial,
    setNovaDataPresencial,
    adicionarAudienciaPresencial,
    adicionarMultiplasLinhasAudienciasPresenciais,
    editandoAudienciaPresencial,
    valorEdicaoAudienciaPresencial,
    setValorEdicaoAudienciaPresencial,
    valorEdicaoNumeroProtocolo,
    setValorEdicaoNumeroProtocolo,
    valorEdicaoDataPresencial,
    setValorEdicaoDataPresencial,
    salvarEdicaoAudienciaPresencial,
    cancelarEdicaoAudienciaPresencial,
    iniciarEdicaoAudienciaPresencial,
    removerAudienciaPresencial,

    // Remotas
    novaAudienciaRemota,
    setNovaAudienciaRemota,
    novoNumeroProcessoRemota,
    setNovoNumeroProcessoRemota,
    novaDataRemota,
    setNovaDataRemota,
    adicionarAudienciaRemota,
    adicionarMultiplasLinhasAudienciasRemotas,
    editandoAudienciaRemota,
    valorEdicaoAudienciaRemota,
    setValorEdicaoAudienciaRemota,
    valorEdicaoNumeroProcessoRemota,
    setValorEdicaoNumeroProcessoRemota,
    valorEdicaoDataRemota,
    setValorEdicaoDataRemota,
    salvarEdicaoAudienciaRemota,
    cancelarEdicaoAudienciaRemota,
    iniciarEdicaoAudienciaRemota,
    removerAudienciaRemota,

    RELATORIO_CORES,
  } = props;

  return (
    <Fragment>
      {/* Sub-etapa 1: Audiências Presenciais */}
      <Card className="mb-4" style={cardStyle}>
        <Card.Header style={headerStyle}>
          <h6 className="mb-0">
            <i className="bi bi-person-video me-2"></i>
            Audiências Presenciais
          </h6>
        </Card.Header>
        <Card.Body>
          {!isViewMode && (
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-bold">Audiência Presencial</Form.Label>
                  <Select
                    classNamePrefix="react-select"
                    value={novaAudienciaPresencial ? { value: novaAudienciaPresencial, label: novaAudienciaPresencial } : null}
                    onChange={(option) =>
                      setNovaAudienciaPresencial(option ? (option as { value: string; label: string }).value : '')
                    }
                    options={TIPOS_AUDIENCIAS.map((tipo: string) => ({ value: tipo, label: tipo }))}
                    placeholder="Digite para buscar..."
                    isClearable
                    isDisabled={isViewMode}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-bold">N.º do Processo</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ex: 0000000"
                    value={novoNumeroProtocolo}
                    onChange={(e) => setNovoNumeroProtocolo(apenasNumeros(e.target.value))}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key) && e.key !== 'Enter' && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-bold">Data</Form.Label>
                  <Form.Control type="date" value={novaDataPresencial} onChange={(e) => setNovaDataPresencial(e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2} className="d-flex align-items-end">
                <Button variant="primary" onClick={adicionarAudienciaPresencial} className="w-100" style={{ borderRadius: '8px' }}>
                  <i className="bi bi-plus-lg me-2"></i>
                  Adicionar
                </Button>
              </Col>
            </Row>
          )}

          {!isViewMode && (
            <Row className="mb-3">
              <Col md={6}>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted">Adicionar</span>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setQuantidadeLinhas((prev) => ({ ...prev, audienciasPresenciais: Math.max(1, prev.audienciasPresenciais - 1) }))}
                  style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
                  title="Diminuir quantidade"
                >
                  <i className="bi bi-dash" aria-hidden="true"></i> -
                </Button>
                <Form.Control
                  type="number"
                  min="1"
                  max="50"
                  value={quantidadeLinhas.audienciasPresenciais}
                  onChange={(e) =>
                    setQuantidadeLinhas((prev) => ({
                      ...prev,
                      audienciasPresenciais: Math.max(1, parseInt(e.target.value) || 1),
                    }))
                  }
                  style={{ width: '60px', textAlign: 'center', borderRadius: '8px' }}
                  size="sm"
                />
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setQuantidadeLinhas((prev) => ({ ...prev, audienciasPresenciais: Math.min(50, prev.audienciasPresenciais + 1) }))}
                  style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
                  title="Aumentar quantidade"
                >
                  <i className="bi bi-plus" aria-hidden="true"></i> +
                </Button>
                <Button variant="outline-primary" size="sm" onClick={adicionarMultiplasLinhasAudienciasPresenciais} style={{ borderRadius: '8px' }}>
                  <i className="bi bi-plus-lg me-1"></i>
                  Adicionar {quantidadeLinhas.audienciasPresenciais} linha{quantidadeLinhas.audienciasPresenciais > 1 ? 's' : ''}
                </Button>
                </div>
              </Col>
            </Row>
          )}

          <Table bordered hover>
            <thead className="table-light">
              <tr>
                <th style={{ width: '5%' }}>#</th>
                <th style={{ width: '30%' }}>Audiência Presencial</th>
                <th style={{ width: '25%' }}>N.º do Processo</th>
                <th style={{ width: '20%' }}>Data</th>
                {!isViewMode && <th style={{ width: '20%' }}>Ações</th>}
              </tr>
            </thead>
            <tbody>
              {formData.audiencias.presenciais.length === 0 ? (
                <tr>
                  <td colSpan={isViewMode ? 4 : 5} className="text-center text-muted">
                    Nenhuma audiência presencial adicionada
                  </td>
                </tr>
              ) : (
                formData.audiencias.presenciais.map((item: AudienciaPresencialItem, index: number) => {
                  const estaEditando = editandoAudienciaPresencial === item.id;

                  return (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>
                        {estaEditando ? (
                          <Select
                            classNamePrefix="react-select"
                            value={
                              valorEdicaoAudienciaPresencial ? { value: valorEdicaoAudienciaPresencial, label: valorEdicaoAudienciaPresencial } : null
                            }
                            onChange={(option) =>
                              setValorEdicaoAudienciaPresencial(option ? (option as { value: string; label: string }).value : '')
                            }
                            options={TIPOS_AUDIENCIAS.map((tipo: string) => ({ value: tipo, label: tipo }))}
                            placeholder="Digite para buscar..."
                            isClearable
                            isDisabled={isViewMode}
                            styles={{ container: (base) => ({ ...base, minWidth: '180px' }) }}
                          />
                        ) : (
                          item.audienciaPresencial
                        )}
                      </td>
                      <td>
                        {estaEditando ? (
                          <Form.Control
                            type="text"
                            size="sm"
                            placeholder="Ex: 0000000"
                            value={valorEdicaoNumeroProtocolo}
                            onChange={(e) => setValorEdicaoNumeroProtocolo(apenasNumeros(e.target.value))}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key) && e.key !== 'Enter' && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                                e.preventDefault();
                              }
                            }}
                            style={{ borderRadius: '8px' }}
                          />
                        ) : (
                          item.numeroProtocolo
                        )}
                      </td>
                      <td>
                        {estaEditando ? (
                          <Form.Control
                            type="date"
                            size="sm"
                            value={valorEdicaoDataPresencial}
                            onChange={(e) => setValorEdicaoDataPresencial(e.target.value)}
                            style={{ borderRadius: '8px' }}
                          />
                        ) : (
                          formatarDataHelper(item.data)
                        )}
                      </td>
                      {!isViewMode && (
                        <td>
                          {estaEditando ? (
                            <div className="d-flex gap-1">
                              <Button
                                style={{ width: '80px', height: '40px' }}
                                variant="success"
                                size="sm"
                                onClick={() => salvarEdicaoAudienciaPresencial(item.id)}
                                title="Salvar"
                              >
                                <i className="bi bi-check-lg"> Salvar</i>
                              </Button>
                              <Button
                                style={{ width: '80px', height: '40px' }}
                                variant="secondary"
                                size="sm"
                                onClick={cancelarEdicaoAudienciaPresencial}
                                title="Cancelar"
                              >
                                <i className="bi bi-x-lg"> Cancelar</i>
                              </Button>
                            </div>
                          ) : (
                            <div className="d-flex gap-1">
                              <Button
                                style={{ width: '80px', height: '40px' }}
                                variant="outline-primary"
                                size="sm"
                                onClick={() => iniciarEdicaoAudienciaPresencial(item)}
                                title="Editar"
                              >
                                <i className="bi bi-pencil"> Editar</i>
                              </Button>
                              <Button
                                variant="danger"
                                size="sm"
                                onClick={() => removerAudienciaPresencial(item.id)}
                                style={{ width: '80px', height: '40px' }}
                                title="Excluir"
                              >
                                <i className="bi bi-trash"> Excluir</i>
                              </Button>
                            </div>
                          )}
                        </td>
                      )}
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
          <div className="mt-2 text-end">
            <h5 className="mb-0" style={{ color: RELATORIO_CORES.PRIMARIA }}>
              <small className="text-muted">Total:</small> {formData.audiencias.presenciais.length}
            </h5>
          </div>
        </Card.Body>
      </Card>

      {/* Sub-etapa 2: Audiências Remotas */}
      <Card className="mb-4" style={cardStyle}>
        <Card.Header style={headerStyle}>
          <h6 className="mb-0">
            <i className="bi bi-camera-video me-2"></i>
            Audiências Remotas
          </h6>
        </Card.Header>
        <Card.Body>
          {!isViewMode && (
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-bold">Audiência Remota</Form.Label>
                  <Select
                    classNamePrefix="react-select"
                    value={novaAudienciaRemota ? { value: novaAudienciaRemota, label: novaAudienciaRemota } : null}
                    onChange={(option) => setNovaAudienciaRemota(option ? (option as { value: string; label: string }).value : '')}
                    options={TIPOS_AUDIENCIAS.map((tipo: string) => ({ value: tipo, label: tipo }))}
                    placeholder="Digite para buscar..."
                    isClearable
                    isDisabled={isViewMode}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-bold">N.º do Processo</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ex: 000000.000.000"
                    value={novoNumeroProcessoRemota}
                    onChange={(e) => setNovoNumeroProcessoRemota(apenasNumeros(e.target.value))}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key) && e.key !== 'Enter' && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-bold">Data</Form.Label>
                  <Form.Control type="date" value={novaDataRemota} onChange={(e) => setNovaDataRemota(e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2} className="d-flex align-items-end">
                <Button variant="primary" onClick={adicionarAudienciaRemota} className="w-100" style={{ borderRadius: '8px' }}>
                  <i className="bi bi-plus-lg me-2"></i>
                  Adicionar
                </Button>
              </Col>
            </Row>
          )}

          {!isViewMode && (
            <Row className="mb-3">
              <Col md={6}>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted">Adicionar</span>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setQuantidadeLinhas((prev) => ({ ...prev, audienciasRemotas: Math.max(1, prev.audienciasRemotas - 1) }))}
                  style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
                  title="Diminuir quantidade"
                >
                  <i className="bi bi-dash" aria-hidden="true"></i> -
                </Button>
                <Form.Control
                  type="number"
                  min="1"
                  max="50"
                  value={quantidadeLinhas.audienciasRemotas}
                  onChange={(e) =>
                    setQuantidadeLinhas((prev) => ({
                      ...prev,
                      audienciasRemotas: Math.max(1, parseInt(e.target.value) || 1),
                    }))
                  }
                  style={{ width: '60px', textAlign: 'center', borderRadius: '8px' }}
                  size="sm"
                />
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setQuantidadeLinhas((prev) => ({ ...prev, audienciasRemotas: Math.min(50, prev.audienciasRemotas + 1) }))}
                  style={{ borderRadius: '8px', width: '32px', height: '32px', padding: 0 }}
                  title="Aumentar quantidade"
                >
                  <i className="bi bi-plus" aria-hidden="true"></i> +
                </Button>
                <Button variant="outline-primary" size="sm" onClick={adicionarMultiplasLinhasAudienciasRemotas} style={{ borderRadius: '8px' }}>
                  <i className="bi bi-plus-lg me-1"></i>
                  Adicionar {quantidadeLinhas.audienciasRemotas} linha{quantidadeLinhas.audienciasRemotas > 1 ? 's' : ''}
                </Button>
                </div>
              </Col>
            </Row>
          )}

          <Table bordered hover>
            <thead className="table-light">
              <tr>
                <th style={{ width: '5%' }}>#</th>
                <th style={{ width: '35%' }}>Audiência Remota</th>
                <th style={{ width: '25%' }}>N.º do Processo</th>
                <th style={{ width: '20%' }}>Data</th>
                <th style={{ width: '15%' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {formData.audiencias.remotas.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center text-muted">
                    Nenhuma audiência remota adicionada
                  </td>
                </tr>
              ) : (
                formData.audiencias.remotas.map((item: AudienciaRemotaItem, index: number) => {
                  const estaEditando = editandoAudienciaRemota === item.id;

                  return (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>
                        {estaEditando ? (
                          <Select
                            classNamePrefix="react-select"
                            value={valorEdicaoAudienciaRemota ? { value: valorEdicaoAudienciaRemota, label: valorEdicaoAudienciaRemota } : null}
                            onChange={(option) =>
                              setValorEdicaoAudienciaRemota(option ? (option as { value: string; label: string }).value : '')
                            }
                            options={TIPOS_AUDIENCIAS.map((tipo: string) => ({ value: tipo, label: tipo }))}
                            placeholder="Digite para buscar..."
                            isClearable
                            isDisabled={isViewMode}
                            styles={{ container: (base) => ({ ...base, minWidth: '180px' }) }}
                          />
                        ) : (
                          item.audienciaRemota
                        )}
                      </td>
                      <td>
                        {estaEditando ? (
                          <Form.Control
                            type="text"
                            size="sm"
                            placeholder="Ex: 000000.000.000"
                            value={valorEdicaoNumeroProcessoRemota}
                            onChange={(e) => setValorEdicaoNumeroProcessoRemota(apenasNumeros(e.target.value))}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key) && e.key !== 'Enter' && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                                e.preventDefault();
                              }
                            }}
                            style={{ borderRadius: '8px' }}
                          />
                        ) : (
                          item.numeroProcesso
                        )}
                      </td>
                      <td>
                        {estaEditando ? (
                          <Form.Control type="date" size="sm" value={valorEdicaoDataRemota} onChange={(e) => setValorEdicaoDataRemota(e.target.value)} style={{ borderRadius: '8px' }} />
                        ) : (
                          formatarDataHelper(item.data)
                        )}
                      </td>
                      <td>
                        {estaEditando ? (
                          <div className="d-flex gap-1">
                            <Button style={{ width: '80px', height: '40px' }} variant="success" size="sm" onClick={() => salvarEdicaoAudienciaRemota(item.id)} title="Salvar">
                              <i className="bi bi-check-lg"> Salvar</i>
                            </Button>
                            <Button style={{ width: '80px', height: '40px' }} variant="secondary" size="sm" onClick={cancelarEdicaoAudienciaRemota} title="Cancelar">
                              <i className="bi bi-x-lg"> Cancelar</i>
                            </Button>
                          </div>
                        ) : (
                          <div className="d-flex gap-1">
                            <Button style={{ width: '80px', height: '40px' }} variant="outline-primary" size="sm" onClick={() => iniciarEdicaoAudienciaRemota(item)} title="Editar">
                              <i className="bi bi-pencil"> Editar</i>
                            </Button>
                            <Button variant="danger" size="sm" onClick={() => removerAudienciaRemota(item.id)} style={{ width: '80px', height: '40px' }} title="Excluir">
                              <i className="bi bi-trash"> Excluir</i>
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
          <div className="mt-2 text-end">
            <h5 className="mb-0" style={{ color: RELATORIO_CORES.PRIMARIA }}>
              <small className="text-muted">Total:</small> {formData.audiencias.remotas.length}
            </h5>
          </div>
        </Card.Body>
      </Card>
    </Fragment>
  );
}

